import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select",
  "use": "icon-select-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select\">\n<rect x=\"0.5\" y=\"0.5\" width=\"23\" height=\"23\" rx=\"1.5\" fill=\"white\" stroke=\"#30C213\" />\n<path d=\"M3.75 12.9455C3.75 12.9455 8.01628 16.4258 8.44006 19.3857C8.44006 19.3857 14.0342 10.2531 20.25 9.43599C20.25 9.43599 18.357 8.06021 18.9786 5.88574C18.9786 5.88574 15.5317 6.22875 9.03339 16.2877L5.98782 11.1321L3.75 12.9455Z\" fill=\"#30C213\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol